<div>
  <div class="dialog-header">
    <h4 mat-dialog-title>Clone repository</h4>
    <button mat-dialog-close matIconButton aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <form [formGroup]="cloneRepoForm">
    <mat-dialog-content>
      <mat-form-field class="clone-field">
        <mat-label>GitLab URL</mat-label>
        <input matInput formControlName="repoURL" placeholder="https://gitlab.com/..." required />
        <mat-hint>Enter the GitLab repository URL to clone.</mat-hint>
      </mat-form-field>
    </mat-dialog-content>
  </form>
  <mat-dialog-actions>
    @if (isLoading$()) {
      <mat-icon><mat-spinner diameter="20"></mat-spinner></mat-icon>
    }
    <button
      matButton="filled"
      (click)="submitFormCloneRepo()"
      [disabled]="cloneRepoForm.invalid || isLoading$()"
    >
      Clone
    </button>
  </mat-dialog-actions>
</div>
